import axios from '../../shared/axios';

export function index({ offset = 0, limit = 10 })
{
    return axios.get('/announcements', { params: { offset, limit } })
        .then(response => response.data);
}

export function markAnnouncementAsRead()
{
    return axios.post('/mark-announcement-as-read')
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            console.error(error);
        });
    // return axios.post('/mark-feature-as-read')
    //     .then(response => response.data);
}

/*
export function update(featureId, data)
{
    return axios.patch('/features/update', {featureId}, data)
        .then(response => response.data);
}
*/
